import { Action } from '@ngrx/store';
import * as moment from 'moment';

import { SlotsResponseOP } from '@cemex-core/cmx-api';


export enum ActionTypes {
  LOAD_SLOT = '[RMS Open Platform Slots] Load Slot',
  LOAD_SLOT_SUCCESS = '[RMS Open Platform Slots] Load Slot Success',
  SLOT_AVAILABLE = '[RMS Open Platform Slots] Slot available',
  SLOT_WAITING_LIST_DEFAULTED = '[RMS Open Platform Slots] Slot waiting list defaulted',
  ERROR = '[RMS Open Platform Slots] Error',
  TRIGGER_RESET_WARNING = '[RMS Open Platform Slots] Trigger Reset Warning',
  RESET = '[RMS Open Platform Slots] Reset',
  CANCEL_RESET = '[RMS Open Platform Slots] Cancel Reset',
  SCHEDULE_AVAILABLE = '[RMS Open Platform Slots] Schedule available',
  ADD_SLOT = '[RMS Open Platform Slots] Add Slot',
  FETCH_SLOT = '[RMS Open Platform Slots] Fetch Slot',
  CLEAN_SLOT = '[RMS Open Platform Slots] Clean Slot',
  CLEAN_ALL_SLOTS = '[RMS Open Platform Slots] Clean All Slots',
  UPDATE_AVAILABLE_SCHEDULE_FLAG = '[RMS Open Platform Slots] Update Available Schedule Flag',

}

export class LoadSlot implements Action {
  readonly type = ActionTypes.LOAD_SLOT;
  constructor(public payload: { moment?: moment.Moment; formIndex: number }) {}
}

export class LoadSlotSuccess implements Action {
  readonly type = ActionTypes.LOAD_SLOT_SUCCESS;
  constructor(public payload: { response: SlotsResponseOP; formIndex: number }) {}
}

export class SlotAvailable implements Action {
  readonly type = ActionTypes.SLOT_AVAILABLE;
  constructor(public payload: { moment: moment.Moment | null; formIndex: number }) {}
}

export class SlotWaitingListDefaulted implements Action {
  readonly type = ActionTypes.SLOT_WAITING_LIST_DEFAULTED;
  constructor(public payload: { itDefaulted: boolean; formIndex: number }) {}
}

export class Error implements Action {
  readonly type = ActionTypes.ERROR;
  constructor(public payload: { error: any; formIndex: number }) {}
}

export class SlotReset implements Action {
  readonly type = ActionTypes.RESET;
  constructor(public payload: number) {}
}

export class SlotTriggerResetWarning implements Action {
  readonly type = ActionTypes.TRIGGER_RESET_WARNING;
  constructor(public payload: number) {}
}

export class SlotCancelReset implements Action {
  readonly type = ActionTypes.CANCEL_RESET;
  constructor(public payload: number) {}
}

export class ScheduleAvailable implements Action {
  readonly type = ActionTypes.SCHEDULE_AVAILABLE;
  constructor(public payload: { scheduleAvailable: boolean; formIndex: number }) {}
}

export class AddSlot implements Action {
  readonly type = ActionTypes.ADD_SLOT;
  constructor(public payload: { formIndex: number; availableSchedule: boolean }) {}
}

export class FetchSlot implements Action {
  readonly type = ActionTypes.FETCH_SLOT;
  constructor(public payload: { formIndex: number; moment?: moment.Moment }) {}
}

export class CleanSlot implements Action {
  readonly type = ActionTypes.CLEAN_SLOT;
  constructor(public payload: { formIndex: number }) {}
}

export class CleanAllSlots implements Action {
  readonly type = ActionTypes.CLEAN_ALL_SLOTS;
  constructor() {}
}

export class UpdateAvailableScheduleFlag implements Action {
  readonly type = ActionTypes.UPDATE_AVAILABLE_SCHEDULE_FLAG;
  constructor(public payload: { formIndex: number; value: boolean }) {}
}




export type Actions =
  | LoadSlot
  | LoadSlotSuccess
  | SlotReset
  | SlotTriggerResetWarning
  | SlotCancelReset
  | Error
  | SlotAvailable
  | SlotWaitingListDefaulted
  | AddSlot
  | FetchSlot
  | CleanSlot
  | CleanAllSlots
  | UpdateAvailableScheduleFlag;
